import { render, staticRenderFns } from "./WatchPointPrice.vue?vue&type=template&id=140a22eb&scoped=true"
import script from "./WatchPointPrice.vue?vue&type=script&lang=js"
export * from "./WatchPointPrice.vue?vue&type=script&lang=js"
import style0 from "./WatchPointPrice.vue?vue&type=style&index=0&id=140a22eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a22eb",
  null
  
)

export default component.exports